export default "__VITE_ASSET__3d5f3d8a__"